import { render } from "./업무적합성_평가.vue?vue&type=template&id=00ff545c"
import script from "./업무적합성_평가.vue?vue&type=script&lang=js"
export * from "./업무적합성_평가.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__